export default __webpack_public_path__ + "static/media/2504151.792cff72.jpg";